import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import NavigationHelper from 'yoda-core-components/lib/helpers/NavigationHelper/NavigationHelper';
import RedirectAction from 'yoda-app-shell/lib/action/RedirectAction';
import CMPageLazy from 'yoda-site-components/lib/components/CoreMediaPage/CMPageLazy';
import IrisPage from 'yoda-site-components/lib/components/IrisPage/IrisPage';
import irisComponentsForCoupon from 'yoda-site-components/lib/iris/components/forCoupon';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import { hotdealsPostProcessor } from 'yoda-interfaces/lib/IrisPage/IrisPage';
import renderMiniPDP from '../../../helper/MiniPDPHelper';
import couponPageAction from '../../../actions/CouponPageAction';

export class CouponPage extends PureComponent {
    static defaultProps = {
        location: {},
        actions: {},
        cmFallbackPreferences: {},
        enableCmPage: false,
        irisFallbackEnabled: false,
        cmFallbackEnabled: false,
        disableIrisCall: false,
        isIrisFallBackEnabled: false,
        irisFallbackPreferences: {},
        enableMiniPDPFeature: true,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        location: PropTypes.objectOf(PropTypes.object),
        cmData: PropTypes.objectOf(PropTypes.object),
        enableCmPage: PropTypes.bool,
        cmFallbackPreferences: PropTypes.arrayOf(PropTypes.object),
        irisFallbackEnabled: PropTypes.arrayOf(PropTypes.bool),
        cmFallbackEnabled: PropTypes.arrayOf(PropTypes.bool),
        disableIrisCall: PropTypes.arrayOf(PropTypes.bool),
        isIrisFallBackEnabled: PropTypes.bool,
        irisFallbackPreferences: PropTypes.objectOf(PropTypes.object),
        enableMiniPDPFeature: PropTypes.bool,
    };

    componentDidMount() {
        const { actions } = this.props;
        actions.getCouponPageLoaded();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps() {
        const catergoryRegex = /\/m\//;

        /* istanbul ignore else */
        if (
            !catergoryRegex.test(window.location.href) &&
            !window.location.href.includes('coupon')
        ) {
            NavigationHelper.navigate(window.location.href);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isIrisFallBackEnabled) {
            return true;
        }
        return false;
    }

    render() {
        const {
            location,
            cmFallbackPreferences,
            enableCmPage,
            isIrisFallBackEnabled,
            history,
            cmData,
            irisFallbackPreferences,
            enableMiniPDPFeature,
        } = this.props; // getting location from router
        /* IRIS endpoint to hit/relative URL  */
        const params = location && location.pathname;
        const isCMTestEnabled = JSON.parse(new URLSearchParams(location?.search).get('cmTest'));
        const renderMiniPDPComponent = enableMiniPDPFeature ? renderMiniPDP() : null;

        const isCMPageEnabled =
            !isIrisFallBackEnabled &&
            (enableCmPage || isCMTestEnabled) &&
            isCMTestEnabled !== false;

        const cmRowData = get(cmData, 'page.grid.rows', []);
        const checkCMDataAvailable = (cmRowData) => {
            const isPlacementDataEmpty = cmRowData
                ?.map((placements) => {
                    return placements?.placements[0];
                })
                .filter((placement) => placement?.name === 'S1' || placement?.name === 'S2')
                .every((placement) => placement?.items?.length === 0);
            return isPlacementDataEmpty;
        };
        const isCMComponentDataEmpty =
            cmRowData?.length > 0 ? checkCMDataAvailable(cmRowData) : false;
        return (
            <>
                {isCMPageEnabled || (!isCMComponentDataEmpty && cmRowData.length > 0) ? (
                    <CMPageLazy
                        params={params}
                        pageType="COUPONS"
                        cmFallbackPreferences={cmFallbackPreferences}
                        redirectAction={RedirectAction.setRedirectUrl}
                        aggregateAPI
                        isCMPageEnabled={isCMPageEnabled}
                        location={location}
                        history={history}
                        title="COUPONTITLE"
                    />
                ) : (
                    (!enableCmPage || isIrisFallBackEnabled) && (
                        <IrisPage
                            params={params}
                            pageType="COUPONS"
                            irisComponents={irisComponentsForCoupon}
                            irisFallbackPreferences={irisFallbackPreferences}
                            aggregateAPI
                            postProcessor={hotdealsPostProcessor}
                            location={location}
                            isFallingBackAfterCMFailed={isIrisFallBackEnabled}
                        />
                    )
                )}
                <Loading />
                {renderMiniPDPComponent}
            </>
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = ({ cmData, context }) => ({
    cmData,
    cmFallbackPreferences: get(context, 'preferences.irisfallbackPreferences', {}),
    irisFallbackEnabled: get(context, 'featureFlags.irisFallbackEnabled', false),
    cmFallbackEnabled: get(context, 'featureFlags.irisFallbackEnabled', false),
    disableIrisCall: get(context, 'featureFlags.disableIrisCall', false),
    cmPageinclusionList: get(context, 'preferences.cmPageInclusionList', []),
    isPreview: get(context, 'isPreview', false),
    enableCmPage: get(context, 'featureFlags.enableCmPage', false),
    isIrisFallBackEnabled: get(cmData, 'isIrisFallBackEnabled', false),
    irisFallbackPreferences: get(context, 'preferences.irisfallbackPreferences', {}),
    enableMiniPDPFeature: get(context, 'featureFlags.enableMiniPDPFeature', true),
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...couponPageAction }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CouponPage));
